import { Component, Story, Knobs, Accents } from './DocTypes';

const BasicStoryKnobs: Knobs = {
  name: { default: 'Settings', editor: 'textbox' },
  heading: { default: 'Access UK Ltd', editor: 'textbox' },
  label: { default: 'Richard Oliver', editor: 'textbox' },
  placeholder: { default: '', editor: 'textbox' },
  'image-src': {
    default:
      'https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&h=350',
    editor: 'textbox',
  },
  accent: { default: 'keppel', editor: 'dropdown', editorOptions: [''].concat(Accents) },
  disabled: { default: false, editor: 'checkbox' },
  selected: { default: false, editor: 'checkbox' },
  'colour-scheme': {
    editor: 'dropdown',
    editorOptions: ['light', 'dark', ''],
    default: '',
  },
};

const PlaygroundStory: Story = {
  title: 'Playground',
  description: 'A side menu for mobile apps',

  coreComponent_v3: {
    html: `<tag3-mobile-side-menu-list-option {{...knobs}}></tag3-mobile-side-menu>`,
    knobs: {
      ...BasicStoryKnobs,
    },
  },
  reactWrapper_v3: {
    jsx: `<TagMobileSideMenuListOption {{...knobs}} />`,
    knobs: {
      ...BasicStoryKnobs,
    },
  },
};

export const TagMobileSideMenuListOptionDocs: Component = {
  type: 'component',
  name: 'mobile-side-menu-list-option',
  description: 'Renders an option for the side menu list for a mobile device',
  mobileFriendly: false,
  popular: false,
  preRelease: 'alpha',
  props: [
    {
      name: 'name',
      description: 'The name of the menu option, will be included in the click event',
      type: 'string',
    },
    {
      name: 'text',
      description: 'The text that will appear in the side menu option',
      type: 'string',
    },
    {
      name: 'icon',
      description: 'An icon to show on the menu option',
      type: 'string',
    },
    {
      name: 'accent',
      description: 'The accent for the background when the item is in an active state (pressed)',
      type: 'Accent',
    },
    {
      name: 'iconAccent',
      description: 'The accent colour of the icon',
      type: 'Accent',
    },
    {
      name: 'type',
      description: 'The type of the menu option',
      type: 'button | toggle',
      default: 'button',
    },
    {
      name: 'disabled',
      description: 'Whether the menu option is disabled',
      type: 'boolean',
    },
    {
      name: 'checked',
      description: 'Then the type is toggle, whether it is checked',
      type: 'boolean',
    },
    {
      name: 'colour-scheme',
      description:
        'Dark mode (theme) control. Undefined for normal browser control. Dark | Light to force respective styling regardless of browser setting.',
      type: 'dark | light',
    },
  ],
  reactPropOverrides: [],
  events: [
    {
      name: 'optionClick',
      description: 'Raised when the side menu option is clicked',
      parameters: [],
    },
  ],
  methods: [],
  stories: [PlaygroundStory],
};
